import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";

import Banner from "../../assets/homeImage/banner.png";

import GradientTextWithStroke from "./index";
import React from "react";

const Privacy = () => {
  const tableData = [
    {
      level: "Level 1",
      channel: "In-Platform Automated Support",
      description:
        "User-friendly automated system for immediate transaction-related queries. We aim to resolve within 24-48 hours.",
    },
    {
      level: "Level 2",
      channel: "Customer Support Team",
      description:
        "Option to speak with a dedicated Customer Support Team via the Digital Venue if Level 1 is unsatisfactory. Resolution attempt within 24-48 hours.",
    },
    {
      level: "Level 3",
      channel: "Grievance Redressal Officer",
      description:
        "For unresolved complaints or grievances pertaining to Terms violations, objectionable content, or access issues.",
    },
  ];

  const tableData1 = [
    {
      category: "Financial Management",
      practice:
        "Only commit funds to your Winnsta Wallet that are within your disposable income. Never use money required for essential expenses such as housing, food, education, or bills. Do not borrow funds to support your activities on the Digital Venue. Avoid deploying all available funds in a single game or session.",
    },
    {
      category: "Time Management",
      practice:
        "Pre-determine your play sessions and the amount of time you spend on the Digital Venue, and stick to this plan. Take regular breaks and time-outs. Ensure your gameplay duration is balanced with other life activities, work, and social engagements.",
    },
    {
      category: "Emotional State",
      practice:
        "Refrain from engaging with the games when you are feeling stressed, depressed, angry, or overly tired. A clear mind is essential for making sound decisions.",
    },
    {
      category: "Priorities",
      practice:
        "Always complete your personal and professional obligations before starting a game session. Gameplay should never take precedence over important tasks.",
    },
    {
      category: "Competency",
      practice:
        "Participate in games that align with your skill level and financial capacity. Resist the urge to enter high-stakes environments, even after a consistent run of successful outcomes.",
    },
  ];

  return (
    <Box backgroundColor={"#3A005E"}>
      <Box
        bgImage={`url(${Banner})`}
        bgSize="cover"
        bgPosition="center"
        w="100%"
        h={{ base: "300px", md: "469px" }}
        px={{ base: 4, md: 20 }}
        py={{ base: 8, md: 12 }}
        color="white"
      >
        <Flex direction="column" justify="center" align="center" h="100%">
          <Box
            textAlign={{ base: "center", md: "right" }}
            ml={{ base: 0, md: "50%" }} // <- sets content to start at 50% width on md screens
          >
            <GradientTextWithStroke
              text="Fair Play Policy"
              desktopFontSize={70}
              mobileFontSize={60}
              strokeColor="#5c2d06"
              strokeWidth={5}
              gradientStops={[
                { offset: "25%", color: "#FAECA4" },
                { offset: "100%", color: "#B5763A" },
              ]}
            />
            <Text
              fontSize={{ base: "16px", md: "25px" }}
              fontStyle="italic"
              fontWeight="500"
              letterSpacing="0.2em"
              mr="280px"
            >
              {/* Winnsta - GAMES */}
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* Section 3: Text */}
      <Box maxW="100%" py={6} px={4}>
        <Text textAlign="center" fontSize="35px" color="white" mb={6}>
          Winnsta Gaming - Fair Play Policy
        </Text>

        <Flex
          width="100%"
          justifyContent="center"
          alignItems="center"
          color="#A1A1A1"
        >
          <Flex
            width={{ base: "90%", md: "80%" }}
            justifyContent="start"
            alignItems="start"
            flexDir={"column"}
          >
            <Text fontSize={"24px"} fontWeight={"bold"} pt="">
              1. Our Commitment to Fairplay
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              <b>Winnsta Gaming ("Winnsta," "We," "us")</b> is dedicated to
              ensuring a<b>level playing field</b> and a fun, trustworthy
              competitive environment for all users (<b> "Users," "you" </b>).
              This <b>Fairplay Policy</b> defines the ethical and technical
              standards expected of every User on our
              <b>Digital Venue</b> (website and application) to guarantee game
              integrity and discourage cheating.<br></br><br></br>
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              By accessing and using our Offerings, you agree to abide by these
              standards. This Policy must be read with our Terms and Conditions
              and <b>Community Standards</b>.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              {" "}
              2. The Definition of Fair Play
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Fair play on the Digital Venue means that all game outcomes are
              determined solely by the{" "}
              <b>skill, knowledge, effort, and strategy</b> of the legitimate
              participants, without any external, dishonest, or unauthorized
              interference.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              {" "}
              3. Prohibited Conduct and Cheating
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              {" "}
              Winnsta maintains a <b>zero-tolerance policy</b> against any
              activity designed to gain an unfair advantage or disrupt the
              experience of other Users. Prohibited conduct includes, but is not
              limited to:
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              {" "}
              3.1 Unfair Assistance
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Collusion:</b> Working together with other Users to gain an
                  unfair advantage in a game, contest, or tournament. This
                  includes sharing information, signaling, or coordinating play
                  to benefit one player at the expense of others.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>"Ghosting" or Account Sharing:</b> Allowing any third party
                  to access or play on your account, or accessing an account
                  that does not belong to you. Your account is for your personal
                  use only.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              3.2 Unauthorized Tools and Software
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Bots and Automation:</b> Using any form of non-human
                  automated program, software, script, "bot," or macro to play
                  games or simulate human activity.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Game Manipulation Software:</b> Using software, exploits,
                  or external tools to modify the game client, interfere with
                  server communication, alter game mechanics, or view
                  information not normally accessible to a player.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              3.3 Fraudulent Activity
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Chip/Coin Dumping:</b> Intentionally losing game currency
                  to another User or account in a coordinated manner to transfer
                  funds unfairly.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>VPN/Proxy Misuse:</b> Using VPNs, proxy services, or other
                  technical means to mask your true geographic location for the
                  purpose of circumventing geographical restrictions or rules.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Exploiting Bugs:</b> Deliberately taking advantage of any
                  defect, fault, or bug in the software or system to gain an
                  unfair advantage, whether financial or competitive. All
                  discovered bugs must be immediately reported to Winnsta.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              3.4 Malicious Behavior
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Griefing or Deliberate Disruption:</b> Engaging in actions
                  designed solely to annoy, harass, or deliberately disrupt the
                  game experience for other players without competitive intent.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Multi-Accounting:</b> Operating or controlling more than
                  the permitted single account for the purpose of gaining a
                  competitive advantage (e.g., entering a single tournament
                  multiple times).
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              4. Security Measures and Monitoring
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Winnsta utilizes a combination of advanced proprietary and
              third-party security technologies to detect and prevent fairplay
              violations:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Real-Time Monitoring:</b> Our systems continuously monitor
                  game session statistics, user behavior, and unique device data
                  to identify suspicious patterns that indicate cheating,
                  collusion, or bot usage.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Behavioral Analysis:</b> We analyze player actions,
                  win/loss ratios, decision-making speed, and funding patterns
                  to flag activities that deviate significantly from typical
                  human behavior.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Security Audits:</b> We conduct regular audits of accounts
                  and transactions, especially for high-value games or frequent
                  withdrawals, to ensure compliance with this Policy and our AML
                  Policy.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              5. Consequences of Policy Violation
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              If Winnsta, at its <b>sole discretion</b>, determines that a User
              has violated any part of this Fairplay Policy, we reserve the
              right to take corrective action, which may include, but is not
              limited to, the following:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  <b> Temporary Suspension:</b> Suspending the User's account
                  for a set period.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  <b> Permanent Ban:</b> Permanently terminating the User's
                  account and blocking future access to the Digital Venue.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  <b> Forfeiture of Assets: </b>Confiscating any game winnings,
                  accumulated bonuses, or amounts involved in the unfair
                  activity.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  <b> Legal Action:</b> Pursuing legal remedies to recover
                  losses or damages incurred by Winnsta or other Users due to
                  the violation.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text
              fontSize="20px"
              color="#A1A1A1"
              textAlign="justify"
              fontWeight={"bold"}
            >
              Our decision on all matters related to fairplay violations is
              final and binding.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              6. Reporting Violations
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              If you suspect any User is violating this Fairplay Policy or
              notice any security vulnerability, you are obligated to report it
              to us immediately. Please use the{" "}
              <b>Grievance Redressal Mechanism</b> detailed in our{" "}
              <b>Terms and Conditions</b> to submit a report. We rely on our
              community to help us maintain the integrity of the Digital Venue.
            </Text>

            <UnorderedList>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  Every user registering for an account must affirm that they
                  are at least 18 years of age.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  Any person who falsifies or misrepresents their age will have
                  all associated privileges and potential benefits forfeited,
                  and may be subject to legal consequences.
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Winnsta does not engage in any marketing or advertising
                  efforts targeting individuals under the age of 18, which is
                  contrary to both ethical standards and corporate values.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              4. Winnsta’s Measures to Encourage Responsibility
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Winnsta may employ systemic tools to help users manage their play:
            </Text>
            <UnorderedList>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Spending Alerts:</b> We may issue notifications to users
                  whose cumulative spending or transaction volume exceeds
                  predefined internal thresholds.
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Session Reminders:</b> Users may receive a notification
                  recommending an optional short break if their game session
                  duration is extended.
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Mandatory Breaks:</b> If a user's session extends beyond a
                  set critical time limit, the Company reserves the right to
                  enforce a non-negotiable time-out, temporarily restricting the
                  user's access to the Digital Venue until the break period is
                  over.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              5. Recognizing Excessive Gaming Habits
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              If you are concerned about your own usage or that of someone you
              know, consider honestly answering the following self-assessment
              questions. If you respond affirmatively to any of these points, it
              may indicate a need for external assistance:
            </Text>
            <UnorderedList>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Do you frequently play games for a longer duration than you
                  originally intended?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you ever continued playing until all the funds in your
                  wallet were depleted?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you neglected to pay bills because you used that money
                  for gaming activities?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you repeatedly tried, without success, to cut down or
                  stop your play entirely?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you ever contemplated illegal acts to secure funds for
                  playing games?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you relied on borrowed money to finance your gaming
                  activities?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Do you experience feelings of distress or guilt due to money
                  or time lost playing games?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Do you primarily use gaming as a way to attempt to meet
                  financial obligations?
                </Text>
              </ListItem>
            </UnorderedList>
            <Text
              fontSize="20px"
              color="#A1A1A1"
              textAlign="justify"
              fontWeight={"bold"}
              pt="20px"
            >
              If you or someone you know answers 'Yes' to any of the above, we
              strongly advise seeking professional consultation or support
              immediately.
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Privacy;
